import { Box, Button, Card, CardActions, CardMedia, Grid } from "@mui/material";
import axios from "axios";
import React from "react";
import { Link as DirectLink } from "react-router-dom";
import { useGlobal } from "../../Helper/Context/GlobalContext";
function ResumeTemplateCard({ user, data, deleteData, setClose }) {
  //------------------------------------------------------error handle

  const handleButtonClick = (e) => {
    // Prevent the click event from propagating to the box
    e.stopPropagation();
  };
  //==================================================Context
  const masukContext = useGlobal();
  const { loginToken, openErrorBox, setErrorServer } = masukContext;

  //------------------------------------------------------handle Delete
  const handleDelete = async (id) => {
    const url =
      process.env.REACT_APP_BASE_URL + "api/ResumeTemplate/resume-template?id=" + id;
    await axios
      .delete(url, {
        headers: {
          Authorization: `bearer ${loginToken}`,
        },
      })
      .then(deleteData(id))
      .catch((error) => {
        if (error.response.data.length < 100) {
          setErrorServer(error.response.data);
        } else {
          setErrorServer(
            "Terjadi error saat delete template, Mohon  coba lagi"
          );
        }
        openErrorBox();
      });
  };

  return (
    <Grid container spacing={2}>
      {data.map((row) => (
        <Grid key={row.pk_id_resume_template} item xs={12} md={4}>
          <Card
            sx={{ maxWidth: 345 }}
            onClick={() => {
              
             
                setClose(row.pk_id_resume_template);
              
            }}
          >
            <CardMedia
              component="img"
              alt="templates"
              image={process.env.REACT_APP_BASE_URL + row.path_thumb_resume_template}
              loading="lazy"
            />
            {user === "super" && (
              <CardActions>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Button
                      variant="contained"
                      color="warning"
                      sx={{ color: "white", borderRadius: "100px" }}
                      size="small"
                      component={DirectLink}
                      to={"/resume-template/edit/" + row.pk_id_resume_template}
                      onClick={(e) => {
                        handleButtonClick(e);
                      }}
                    >
                      Edit
                    </Button>

                    <Button
                      variant="contained"
                      color="error"
                      sx={{ color: "white", borderRadius: "100px" }}
                      size="small"
                      onClick={(e) => {
                        handleButtonClick(e);
                        handleDelete(row.pk_id_resume_template);
                      }}
                    >
                      Hapus
                    </Button>
                  </Box>
                </Box>
              </CardActions>
            )}
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default ResumeTemplateCard;
